import React from "react";
import { connect } from "react-redux";
import { Routes, Route } from "react-router-dom";
import { About, Contact, Home, Services, Terms, TransactionStatus } from "./Pages";
import BookDemo from "./Pages/BookDemo";
import ProtectedRoute from "./ProtectedRoute";

export const Router = () => {
  return (
    <Routes>
      <Route path="/" exact element={<Home />} />
      <Route path="/services" exact element={<Services />} />
      <Route path="/about" exact element={<About />} />
      <Route path="/contact" exact element={<Contact />} />
      <Route path="/book/manage" exact element={<BookDemo />} />
      <Route path="/book" exact element={<BookDemo />} />
      <Route path="/terms" exact element={<Terms />} />
      <Route path="/transaction/processed" element={<TransactionStatus />} />
    </Routes>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Router);
